import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { useTranslation } from 'react-i18next'
import PostItem from '../components/PostItem/postItem'
import RelatedPostsSlickSlider from '../sections/RelatedPosts/RelatedPostsSlickSlider'

const TfisPosts = ({ category }) => {
    const { i18n } = useTranslation()

    const allTfisPosts = useStaticQuery(
        graphql`
            query FetchAllTfisPosts {
                allContentfulPosts(filter: { tags: { in: "tfis" } }, sort: { published: DESC }, limit: 20) {
                    nodes {
                        id
                        slug
                        tags
                        title
                        metaDesc
                        published(formatString: "D/MM/YYYY")
                        node_locale
                        featuredImage {
                            title
                            description
                            url
                            gatsbyImageData(
                                placeholder: BLURRED
                                height: 1920
                                width: 1920
                                quality: 75
                                sizes: "(max-width: 576px) 768px, (max-width: 768px) 960px, (max-width: 960px) 1200px"
                                layout: FULL_WIDTH
                                breakpoints: [576, 768, 960, 1200, 1920]
                            )
                        }
                    }
                }
            }
        `
    )

    const items = allTfisPosts.allContentfulPosts.nodes
    const filteredItems = category ?
        items.filter(({ tags }) => tags.indexOf(category) > -1) :
        items;

    return (
        <RelatedPostsSlickSlider>
            {filteredItems
                .map((item) => item.node_locale === i18n.language && <PostItem key={item.id} {...item} />)}
        </RelatedPostsSlickSlider>
    )
}

export default TfisPosts
